import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Images from "./Images";
import Card from "react-bootstrap/Card";
import Button from 'react-bootstrap/Button';
import { Container, Row, Col } from "react-bootstrap";
import pdf from "../../Assets/../Assets/TINASHE MANGONDO.pdf";

const App = () => {
  const settings = {
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1000,

  nextArrow: (
    <div>
      <div className="next-slick-arrow"> ⫸ </div>
    </div>
  ),
  prevArrow: (
    <div>
      <div className="prev-slick-arrow"> ⫷ </div>
    </div>
  ),
    };
    return (
      // <div className="content-move">
      //   <div class="card" style="width: 18rem;">
      //   <h1 className="header-move">Car Gallery</h1>
      //   <div className="container-move">
      //     <Slider {...settings}>
      //       {Images.map((item) => (
      //         <div key={item.id}>
      //           <img src={item.src} alt={item.alt} className="img-move" />
      //           <h2 className="title-move">{item.title}</h2>
      //           {/* <p className="description-move">{item.description}</p> */}
      //         </div>
      //       ))}
      //     </Slider>
      //     </div>
      //   </div>
      // </div>
      
      //   <Slider {...settings}>
      //     {Images.map((item) => (
      //       <Card className="move-card-view">
      //         <Card.Img variant="mo" src={item.src} alt="card-img" />
      //            <Card.Body>
      //               <Card.Title>{item.title}</Card.Title>
      //                <Card.Text style={{ textAlign: "justify" }}>
      //                {item.description}
      //               </Card.Text>
      //             </Card.Body>
      //         </Card>
      //     ))}
      // </Slider>   
       
      // );
      <Container>
<Slider {...settings}>
    {Images.map((item) => (
      <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
      {/* <Col md={4} className="project-card"> */}
    <Card border={item.border} className="move-card-view" style={{ width: '50rem' }}>
    <Card.Header>{item.title}</Card.Header>
    <Card.Body>
      {/* <Card.Title>{item.title}</Card.Title> */}
      <Card.Text>
      {item.description}
      </Card.Text>
    </Card.Body>
    <Card.Footer>
    <Button variant="primary" size="sm" href={pdf}>
          Hire Me
        </Button>{' '}
       </Card.Footer>
  </Card>
  {/* </Col> */}
  </Row>
  ))}
  </Slider> </Container>
    );
  }
  export default App;
